module.exports = __webpack_public_path__ + "media/images/signal-strength-40-0c448998ecb6c32bfd8fa6ef5a108596.svg";